import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditQuestion = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Editing Question'
      fields={fields}
      apiPath={`admin/questions/${props.params.questionId}`}
      successRedirectPath='/write-now/questions'
      buildMenuItems={menuItems}
    />
  )
}

export default EditQuestion
